import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DepositDeductionDialogData {
    name: string;
    email: string;
    deposit: number;
}

export interface DepositDeductionDialogResult {
    amount: number;
    reason: string;
}

@Component({
    selector: 'app-deposit-deduction-dialog',
    templateUrl: './deposit-deduction-dialog.component.html',
    styleUrls: ['./deposit-deduction-dialog.component.scss']
})
export class DepositDeductionDialogComponent {
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<DepositDeductionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DepositDeductionDialogData,
        private readonly fb: FormBuilder
    ) {
        this.form = this.fb.group({
            amount: [
                null,
                [
                    Validators.required,
                    Validators.min(0.01),
                    Validators.max(Math.max(0, Number(data.deposit ?? 0)))
                ]
            ],
            reason: ['', [Validators.required, Validators.maxLength(500)]]
        });
    }

    get availableDeposit(): number {
        return Number(this.data.deposit ?? 0);
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        if (this.form.invalid || this.availableDeposit <= 0) {
            this.form.markAllAsTouched();
            return;
        }

        const value = this.form.value;
        this.dialogRef.close({
            amount: Number(value.amount),
            reason: String(value.reason ?? '').trim()
        } satisfies DepositDeductionDialogResult);
    }
}
